import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

const Impressum = () => {
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="impressum-page">
      <Navbar />
      <div className="hero-glow" />
      <main className="pt-20 relative">
        {/* Hero Section - Lebendiges Layout */}
        <section className="py-12 md:py-16 relative overflow-hidden">
          <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="max-w-3xl"
            >
              <span className="text-primary text-sm font-semibold uppercase tracking-widest mb-6 block">
                Rechtliches
              </span>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold tracking-tight leading-[1.1] mb-6" data-testid="impressum-headline">
                Impressum
              </h1>
              <p className="text-lg text-muted-foreground leading-relaxed max-w-xl">
                Angaben gemäß § 5 TMG
              </p>
            </motion.div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-12 md:py-16 bg-[#0A0A0A]">
          <div className="max-w-4xl mx-auto px-6 md:px-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="space-y-8"
            >
              <div className="bg-card/30 border border-white/10 rounded-2xl p-8">
                <h2 className="text-xl font-heading font-semibold text-white mb-4">Anbieter</h2>
                <div className="text-muted-foreground space-y-1">
                  <p className="text-white font-medium">MEHRAZAV</p>
                  <p>Maximilian Trost</p>
                  <p>Zum Großen Zernsee 2H</p>
                  <p>14542 Werder (Havel)</p>
                </div>
              </div>

              <div className="bg-card/30 border border-white/10 rounded-2xl p-8">
                <h2 className="text-xl font-heading font-semibold text-white mb-4">Kontakt</h2>
                <div className="text-muted-foreground space-y-1">
                  <p>Telefon: <a href="tel:+4917670401954" className="text-white hover:text-primary transition-colors">+49 176 7040 1954</a></p>
                  <p>E-Mail: <a href="mailto:hey@mehrazav.de" className="text-white hover:text-primary transition-colors">hey@mehrazav.de</a></p>
                </div>
              </div>

              <div className="bg-card/30 border border-white/10 rounded-2xl p-8">
                <h2 className="text-xl font-heading font-semibold text-white mb-4">Umsatzsteuer-ID</h2>
                <p className="text-muted-foreground">
                  Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                  <span className="text-white">in Beantragung</span>
                </p>
              </div>

              <div className="bg-card/30 border border-white/10 rounded-2xl p-8">
                <h2 className="text-xl font-heading font-semibold text-white mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
                <div className="text-muted-foreground space-y-1">
                  <p className="text-white">Maximilian Trost</p>
                  <p>Zum Großen Zernsee 2H</p>
                  <p>14542 Werder (Havel)</p>
                </div>
              </div>

              <div className="bg-card/30 border border-white/10 rounded-2xl p-8">
                <h2 className="text-xl font-heading font-semibold text-white mb-4">Streitschlichtung</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit. 
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>

              <div className="bg-card/30 border border-white/10 rounded-2xl p-8">
                <h2 className="text-xl font-heading font-semibold text-white mb-4">Haftung für Inhalte</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                  nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                  Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                  Informationen zu überwachen.
                </p>
              </div>
            </motion.div>
          </div>
        </section>
      </main>
      <Footer />
      <div className="noise-overlay" />
    </div>
  );
};

export default Impressum;
